import React from 'react'
import styled from 'styled-components'
import { compose, color, space, typography } from 'styled-system'

const DownloadButtonStyle = styled.a`
  ${compose(
    color,
    space,
    typography,
  )}
  ${({ isUnderline }) => isUnderline && `text-decoration: underline;`}
`
DownloadButtonStyle.defaultProps = {
  color: `primary.2`,
  fontWeight: 500,
  fontSize: `1`,
  isUnderline: false,
}

const DownloadButton = ({ href, children, isUnderline }) => {
  return (
    <DownloadButtonStyle href={href} isUnderline={isUnderline}>
      {children}
    </DownloadButtonStyle>
  )
}
export default DownloadButton
